module.exports = "https://static.wmbcdn.com/uniweb/images/d7447c1bd4056f48d31d34999f7da2ce.svg";